module.exports = __webpack_public_path__ + "img/avatar_google.e5cf4da6.png";